import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, Bell, CheckCircle, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ValuePropsSection = () => {
  const { t } = useTranslation();
  
  const VALUE_PROPS = [
    {
      icon: Calendar,
      title: t('landing.valueProps.calendar'),
      text: t('landing.valueProps.calendarText'),
    },
    {
      icon: Bell,
      title: t('landing.valueProps.reminders'),
      text: t('landing.valueProps.remindersText'),
    },
    {
      icon: CheckCircle,
      title: t('landing.valueProps.responsibility'),
      text: t('landing.valueProps.responsibilityText'),
    },
    {
      icon: Zap,
      title: t('landing.valueProps.quickStart'),
      text: t('landing.valueProps.quickStartText'),
    },
  ];
  
  return (
    <section className="py-16 bg-muted/50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-12 text-center">
          {t('landing.valueProps.title')}
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {VALUE_PROPS.map((prop, index) => {
            const Icon = prop.icon;
            return (
              <Card key={index} className="text-center">
                <CardHeader>
                  <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-lg">{prop.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground">{prop.text}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
